import { createDateTimeColumn } from '@app/components/date/create-date-time-column';
import { createActionsColumn } from '@app/modules/audit/components/create-actions-column';
import { createCustomIdColumn } from '@app/modules/audit/components/create-custom-id-column';
import {
  createStatusColumn,
  scheduleListStatusColumnHeaderMessage,
} from '@app/modules/audit/components/create-status-column';
import { createScheduleMetadataColumns } from '@app/modules/audit/modules/station-audit/screens/schedules-list/create-schedule-metadata-columns';
import { AuditSchedule } from '@mi-front/core';
import { MRT_ColumnDef } from 'material-react-table';
import { MessageDescriptor, useIntl } from 'react-intl';

export interface UseSchedulesListColumnsOptions {
  /** Optional override for the custom-id column header (e.g. mention id). */
  customIdHeader?: MessageDescriptor;
  /** Status column cell renderer. */
  statusCell: NonNullable<MRT_ColumnDef<AuditSchedule>['Cell']>;
  /** Actions column cell renderer. */
  actionsCell: NonNullable<MRT_ColumnDef<AuditSchedule>['Cell']>;
  /** Override the default compact actions column width. */
  actionsColumnSize?: number;
}

/**
 * Shared datetime / custom-id / metadata / status / actions columns for schedule list tables.
 */
export function useSchedulesListColumns({
  customIdHeader,
  statusCell,
  actionsCell,
  actionsColumnSize,
}: UseSchedulesListColumnsOptions): MRT_ColumnDef<AuditSchedule>[] {
  const { $t } = useIntl();

  return [
    createDateTimeColumn<AuditSchedule>($t, {
      accessor: (schedule) => schedule.datetime,
      size: 130,
    }),
    createCustomIdColumn<AuditSchedule>($t, {
      accessor: (row) => row.customId,
      header: customIdHeader,
      size: 140,
      filterField: 'customId',
    }),
    ...createScheduleMetadataColumns($t),
    createStatusColumn<AuditSchedule>($t, {
      header: scheduleListStatusColumnHeaderMessage,
      Cell: statusCell,
    }),
    createActionsColumn<AuditSchedule>($t, {
      size: actionsColumnSize,
      Cell: actionsCell,
    }),
  ];
}
